(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const slides = [...root.querySelectorAll('[data-sleep-slide]')];
    const thumbs = [...root.querySelectorAll('[data-sleep-thumb]')];
    const modal = root.querySelector('[data-sleep-modal]');
    const modalImage = root.querySelector('[data-sleep-modal-image]');
    let index = 0;
    function show(next) {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
      const thumb = thumbs[index];
      thumb?.parentElement.scrollTo({ left: thumb.offsetLeft - thumb.parentElement.offsetLeft, behavior: 'smooth' });
      modalImage.src = slides[index].src;
      modalImage.alt = slides[index].alt;
    }
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    root.querySelectorAll('[data-sleep-prev]').forEach(button => button.addEventListener('click', () => show(index - 1)));
    root.querySelectorAll('[data-sleep-next]').forEach(button => button.addEventListener('click', () => show(index + 1)));
    root.querySelector('[data-sleep-zoom]').addEventListener('click', () => { if (slides.length) { show(index); modal.showModal(); } });
    root.querySelector('[data-sleep-close]').addEventListener('click', () => modal.close());
    modal.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
    });
    root.querySelectorAll('.sk-info-trigger').forEach(button => button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      root.querySelectorAll('.sk-info-trigger').forEach(other => {
        const expanded = other === button && open;
        other.setAttribute('aria-expanded', String(expanded));
        other.classList.toggle('is-open', expanded);
        const panel = document.getElementById(other.getAttribute('aria-controls')) || other.nextElementSibling;
        panel?.classList.toggle('is-open', expanded);
      });
    }));
    root.querySelectorAll('.sk-faq__question').forEach(button => button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      root.querySelectorAll('.sk-faq__question').forEach(other => {
        const expanded = other === button && open;
        other.setAttribute('aria-expanded', String(expanded));
        other.closest('.sk-faq__item').classList.toggle('is-open', expanded);
      });
    }));
    root.querySelectorAll('.sk-guarantee__cta').forEach(button => button.addEventListener('click', () => root.querySelector('#mwSleepPurchase').scrollIntoView({ behavior: 'smooth' })));
    const form = root.querySelector('[data-sleep-form]');
    const packs = [...root.querySelectorAll('[data-sleep-pack]')];
    form.addEventListener('change', event => {
      if (event.target.name !== 'quantity') return;
      packs.forEach(pack => {
        const active = pack.dataset.sleepPack === event.target.value;
        pack.classList.toggle('is-selected', active);
        pack.querySelector('.mw-sleep__colors').hidden = !active;
      });
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('[type=submit]');
      if (button.disabled) return;
      const error = form.querySelector('[role=alert]');
      error.hidden = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      try {
        const selected = packs.find(pack => pack.querySelector('[name=quantity]').checked);
        const items = new Map();
        selected.querySelectorAll('[data-sleep-variant]').forEach(select => {
          if (!select.value || select.selectedOptions[0]?.disabled) throw new Error(root.dataset.error);
          const id = Number(select.value);
          items.set(id, (items.get(id) || 0) + 1);
        });
        const response = await fetch(root.dataset.cartUrl + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [...items].map(([id, quantity]) => ({ id, quantity })), sections: ['cart-drawer-section'], sections_url: location.pathname })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || root.dataset.error);
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (drawer && result.sections?.['cart-drawer-section']) {
          const { morphSection } = await import('@theme/section-renderer');
          await morphSection('cart-drawer-section', result.sections['cart-drawer-section']);
          await customElements.whenDefined('theme-drawer');
          document.querySelector('theme-drawer#cart-drawer')?.open();
        } else {
          location.href = root.dataset.cartPage;
        }
      } catch (failure) {
        error.textContent = failure.message || root.dataset.error;
        error.hidden = false;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  }
  document.querySelectorAll('[data-sleep-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-sleep-product]')));
})();
